export default __webpack_public_path__ + "images/0xf972daced7c6b03223710c11413036d17eb298f6.png";